import { Block } from './Block';

export interface ConsultationCompany {
  id: string;
  name: string;
}

/** Ligne ajoutée par une entreprise (hors devis interne) */
export interface ConsultationCompanyLine {
  id: string;
  companyId: string;
  intitule: string;
  unite?: string | null;
  quantite?: number | null;
  prixUnitaire?: number | null;
}

export interface ConsultationOffer {
  companyId: string;
  blockId: string;
  prixUnitaire: number | null; // null = en attente
  quantite?: number | null;    // null = utiliser la quantité interne
  unite?: string | null;       // null = utiliser l'unité interne
}

export type ConsultationStatus = 'draft' | 'sent' | 'attributed';

export interface Consultation {
  id: string;
  name: string;
  blocks: Block[];            // sections parentes + prestations sélectionnées
  companies: ConsultationCompany[];
  offers: ConsultationOffer[];
  status: ConsultationStatus;
  retainedCompanyId?: string; // défini quand status = 'attributed'
  companyLines?: ConsultationCompanyLine[]; // lignes ajoutées par les entreprises
  createdAt: Date;
}

/** Génère des offres mock ±20% autour du prix interne, ~28% en attente */
export function generateMockOffers(
  blocks: Block[],
  companies: ConsultationCompany[]
): ConsultationOffer[] {
  const offers: ConsultationOffer[] = [];
  for (const company of companies) {
    for (const block of blocks) {
      const internalPU = parseFloat(block.content.prixUnitaire ?? '0');
      const isPending = Math.random() < 0.28;
      const variation = 1 + (Math.random() * 0.4 - 0.2);
      offers.push({
        companyId: company.id,
        blockId: block.id,
        prixUnitaire: isPending || internalPU === 0
          ? null
          : Math.round(internalPU * variation * 100) / 100,
        quantite: null,
        unite: null,
      });
    }
  }
  return offers;
}
